export default "__VITE_ASSET__BBbucb52__"